import {repeat} from 'lit-html/directives/repeat';
import {until} from 'lit-html/directives/until';
import {generalLabels, searchLabels} from '@modules/i18n-labels';
import '@modules/dropdown';
import {LoadingEllipses} from '@epg/epg-components';
import '@modules/object-search-form';

const getButtonLabel = (ctx, html, groupId, index) => {
  if (ctx.selectedGroupsInfo?.[groupId]?.name) {
    return ctx.selectedGroupsInfo?.[groupId]?.name;
  }
  if (ctx.tierStructureLabels?.[index + ctx.adminGroup.level - 1]) {
    return until(ctx._r(ctx.__('<tt-yC0RMGhh>', 'Select %r1%'), ctx.tierStructureLabels?.[index + ctx.adminGroup.level - 1]));
  }
  return until(ctx.__('<tt-PgMgRak+>', 'Select Class'));
};

const renderRegularDropDownFilter = (ctx, html, groupId, level, i) => {
  return html`
      <ems-dropdown
        class="mr-3 mb-3 ${ctx['full-width'] ? 'full-width' : ''}
        group-dropdown-${i}" id="group-dropdown-${ctx.rndId}-${i}"
        @on-open="${() => ctx.toggleDropdown(groupId, i)}">
        <button type="button"
          slot="dropdown-toggle"
          class="btn btn-outline-light d-flex justify-content-between ${ctx['full-width'] ? 'w-100 justify-content-between' : ''}"
          data-hide-pii="true"
          data-bi-id="group_select_${groupId}"
          data-bi-action="Group Select ${groupId}">
          <span id="toggle-text">
            ${getButtonLabel(ctx, html, groupId, i)}
          </span>
          <span class="ai ai-chevron-down"></span>
        </button>
        <div slot="dropdown-menu" class="dropdown-menu m-0 w-100 px-2" id="obj-dropdown-${i}">
          ${getSearchBar(ctx.groupsAtLevel?.[level]?.has_more, groupId, i, level, ctx, html)}
          ${ctx.loading ?
            html`
              <loading-ellipses class="mx-auto d-block py-2"></loading-ellipses>` :
            (ctx.groupsAtLevel?.[level]?.results?.length) ?
              html`
                ${repeat(ctx.groupsAtLevel?.[level]?.results, (group) => group, (group) => renderButton(ctx, html, group, groupId))}
                ${ctx.groupsAtLevel?.[level]?.has_more ? html`
                  <div class="px-4 text-muted border-dashed-top h5 font-weight-normal pt-3">
                    ${until(searchLabels.showingFirstOfAmount(ctx.limit))}
                  </div>
                ` : ``}
              ` :
      html`<div class="px-4 h4 font-weight-normal pt-3">${until(searchLabels.NO_MATCHING_RESULTS)}</div>`}
        </div>
      </ems-dropdown>
    `;
};

const getSearchBar = (hasMore, groupId, dropdownIndex, level, ctx, html) => {
  if (hasMore || ctx.search?.query) {
    return html`
      <object-search-form
        id="obj-search-form-${dropdownIndex}"
        class="border-dashed-bottom"
        @on-search="${(e) => ctx.triggerSearch(e, groupId, dropdownIndex)}"
        .placeholder="${until(ctx.tierStructureLabels?.[level - 2] ? ctx.i18n._r(ctx.i18n.__('<tt-ouEQsqND>', 'Search %r1%'), ctx.tierStructureLabels?.[level - 2]) : ctx.i18n.__('<tt-zNdmpcoq>', 'Search Class'))}"
        .column-layout="${true}"
        reset-text="Reset"></object-search-form>`;
  }
};

const renderButton = (ctx, html, group, selectedGroupId) => {
  return html `<button
    type="button"
    class="btn dropdown-item ${selectedGroupId === group.id ? 'active' : ''}"
    @click="${(e) => ctx.selectGroup(group) }"
    data-hide-pii="true"
    data-bi-id="group_select_${group.id}"
    data-bi-action="Group Select ${group.id}">
    ${group.name}
  </button>`;
};

export default (ctx, html) => {
  const itemTemplates = [];
  for (let i = 0; i <= ctx['selected-groups']?.length; i++) {
    const groupId = ctx['selected-groups'][i];
    const level = groupId ?
      ctx.selectedGroupsInfo[groupId]?.path?.split('.').length :
      i + ctx.adminGroup.level + 1;
    if (
      (ctx['max-level'] && i >= ctx['max-level']) ||
      level > ctx.classLevel ||
      ctx.adminGroup.level > level
    ) {
      continue;
    }

    itemTemplates.push(renderRegularDropDownFilter(ctx, html, groupId, level, i));
  }

  if (ctx['show-reset'] && ctx['selected-groups']?.length > 0) {
    itemTemplates.push(
      html`<button type="button" class="btn btn-link" @click="${ctx.resetFilter}" data-bi-id="reset_group_filters">${until(generalLabels.reset)}</button>`
    );
  }
  return html`${itemTemplates}`;
};
